import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

// import {
//   Row,
//   Col,
//   Card,
// } from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../../utils/store.tsx';
import slice from '../slice.tsx';
import jobFormSlice, { driverMarkerIcon, arrowMarkerIcon, defaultMarkerIcon } from '../../../slice.tsx';

// enums
import { getDefLatLngZoomV4, convertCoordToLatLng, validateLatLng, dinamicZoom } from '../../../../../utils/utils.tsx';
// import {  } from '../../../../../../v5/utils/enums.tsx';

// import {  } from '../../../../manage/jobs/jobTypes/slice.tsx';

// components
// import MainContainer from '../../../../../../v5/components/container/MainContainer.jsx';
import GoogleMap, { addMarker, clearAllMarkers, addPolyline, clearAllPolyline } from '../../../../../components/googleMap/GoogleMap.jsx';

// import { ReactComponent as XIcon } from "../../../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------


const Map = () => {
  const defaultLatLngZoom: any = getDefLatLngZoomV4();
  // const location = useLocation();
  // const router = useRouter();

  const { showDriverTrackng, detailsDriverTrackng, isLoadingDriverTrackng, itemsDriverTrackng } = useTypedSelector((state: RootState) => state.jobFormAuditTrailSlice);
  // const { latestLocationDrivers, directions } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();

  const [map, setMap] = React.useState<any>(null);

  const driversMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const polylineRef = React.useRef<Array<google.maps.Polyline>>([]);

  const [showTrafficLayer, setShowTrafficLayer] = React.useState<any>(false);
  const [customButtons, setCustomButtons] = React.useState<Array<any>>([]);


  React.useEffect(() => {
    if(showDriverTrackng){
      setShowTrafficLayer(false)
    }
  }, [showDriverTrackng]);

  React.useEffect(() => {
    setCustomButtons([
      {
        element: 'button',
        text: showTrafficLayer ? 'Hide traffic' : 'Show traffic',
        className: 'btn btn-custom-outlined btn-sm m-8',
        style: {
          position: 'absolute',
          bottom: '25px',
          right: '10px',
        },
        visible: true,
        disabled: false,
        callback: (e: any) => setShowTrafficLayer(!showTrafficLayer),
      }
    ]);
  }, [showTrafficLayer]);


  React.useEffect(() => {
    clearAllMarkers(driversMarkersRef);
    clearAllPolyline(polylineRef);

    if(map && showDriverTrackng){
      if(itemsDriverTrackng && itemsDriverTrackng.length > 0){
        let countStarted = 0;
        let countInProgress = 0;
        let countCompleted = 0;
        let statusColor = '#7F818D';
        let state = false;
        let zIndex = 0;

        itemsDriverTrackng.forEach((item: any, i: number) => {
          if((countStarted === 0) && (item.statusDisplay.toString().toLowerCase().trim().replace(' ', '') === 'started')){
            countStarted = countStarted + 1;
            statusColor = '#185CFF';
            state = true;
            zIndex = 1;
          } else if((countInProgress === 0) && (item.statusDisplay.toString().toLowerCase().trim().replace(' ', '') === 'inprogress')){
            countInProgress = countInProgress + 1;
            statusColor = '#BD1FF5';
            state = true;
            zIndex = 2;
          } else if((countCompleted === 0) && (item.statusDisplay.toString().toLowerCase().trim().replace(' ', '') === 'completed')){
            countCompleted = countCompleted + 1;
            statusColor = '#43936C';
            state = true;
            zIndex = 3;
          } else {
            state = false;
            zIndex = 0;
          }

          if(state){
            let position = { lat: item.latitude, lng: item.longitude };

            addMarker(driversMarkersRef, {
              map: map,
              position: position,
              title: 'Updated: ' + item.updatedDisplay,
              zIndex: zIndex,
              ...item,
              ...driverMarkerIcon(item.statusDisplay + '\n\r' + item.updatedDisplay, statusColor),
            })
          }
        });
        

        addPolyline(polylineRef, itemsDriverTrackng.map((x: any) => ({ lat: x.latitude, lng: x.longitude })), {
          map: map,
          strokeColor: "#185CFF",
          strokeOpacity: 0.5,
          strokeWeight: 4,
        });


        let currentStatus = (detailsDriverTrackng && detailsDriverTrackng.currentStatus && detailsDriverTrackng.currentStatus != '') ? detailsDriverTrackng.currentStatus : null;
        let itm = itemsDriverTrackng.find((x: any) => x.statusDisplay === currentStatus)
        if(itm){
          let position = { lat: itm.latitude, lng: itm.longitude };
          map.setCenter(position);
          dinamicZoom(map, position.lat, position.lng, 0.0020);
        }
      }
    }
  }, [showDriverTrackng, itemsDriverTrackng, map, window.google])


  return <Spin spinning={false}>
    <div style={{ height: 'calc(100vh - 205px)' }}>
      <GoogleMap
        canConextMenu={false}
        showTrafficLayer={showTrafficLayer}
        customButtons={customButtons}
        options={{
          center: defaultLatLngZoom.coord,
          zoom: defaultLatLngZoom.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true,
          cameraControl: false,
          fullscreenControl: false,
          gestureHandling: "cooperative",
        }}
        onLoad={(map: any, ref: any) => {
          setMap(map);
        }}
      />
    </div>
  </Spin>
}

export default Map;
